//
//
//
//
//
//

export default {
    props:{
        loadingWord:{
            type:String,
            default:""
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/scroll/base/Pulling-word.vue